import client from './client';

// VẬN HÀNH (port app "i love GTS"): mọi lời gọi SocSon đi qua backend /api/ops/sx/* bằng token SocSon
// RIÊNG của NV đang đăng nhập. 409 { code: 'OPS_LOGIN' } = cần đăng nhập lại SocSon (OpsGate bắt sự kiện).
const sx = (config) =>
  client({ ...config, url: `/ops/sx${config.url}` })
    .then((r) => r.data)
    .catch((e) => {
      if (e?.response?.data?.code === 'OPS_LOGIN') {
        try { window.dispatchEvent(new CustomEvent('ft:ops-login')); } catch { /* ignore */ }
      }
      throw e;
    });

// Lỗi đọc được cho người dùng (SocSon trả { message }).
export const opsErr = (e, fallback = 'Có lỗi xảy ra') => e?.response?.data?.message || e?.message || fallback;
// SocSon: thành công khi code == 1 (riêng /api/bills và /api/partner là code == 0).
export const okCode = (d, ok = 1) => d && Number(d.code) === ok;

// Bắt 409 OPS_LOGIN cho các API ops KHÔNG đi qua /sx (thông báo gộp) -> báo OpsGate hiện lại form đăng nhập.
const opsReq = (p) =>
  p.then((r) => r.data).catch((e) => {
    if (e?.response?.data?.code === 'OPS_LOGIN') {
      try { window.dispatchEvent(new CustomEvent('ft:ops-login')); } catch { /* ignore */ }
    }
    throw e;
  });

// Tài khoản SocSon của tôi (chính + danh sách chỉ-nhận-thông-báo trong .notifyAccounts)
export const getOpsAccount = () => client.get('/ops/account').then((r) => r.data);
export const linkOpsAccount = (username, password, remember) =>
  client.post('/ops/account', { username, password, remember }).then((r) => r.data);
export const unlinkOpsAccount = () => client.delete('/ops/account').then((r) => r.data);

// Tài khoản PHỤ chỉ-nhận-thông-báo (tối đa vài cái)
export const linkOpsNotifyAccount = (username, password, remember) =>
  client.post('/ops/notify-account', { username, password, remember }).then((r) => r.data);
export const unlinkOpsNotifyAccount = (id) => client.delete(`/ops/notify-account/${id}`).then((r) => r.data);

// Đơn hàng (quote)
export const quoteByCode = (code) => sx({ method: 'GET', url: `/api/quote/code/${encodeURIComponent(code)}` });
export const quotesByQuery = (code) =>
  sx({ method: 'GET', url: `/api/quote/get-basic-quotes-by-query-string/${encodeURIComponent(code)}` });
export const quoteImages = (params) => sx({ method: 'GET', url: '/api/quote/all/image', params });
export const uploadQuoteImages = (code, typeImage, files) => {
  const fd = new FormData();
  fd.append('code', code);
  fd.append('type_image', typeImage);
  files.forEach((f) => fd.append('files', f, f.name || 'image.jpg'));
  return sx({ method: 'POST', url: '/api/quote/upload/image', data: fd });
};

// Nhặt hàng (phiếu xuất kho)
export const listBills = (params) => sx({ method: 'GET', url: '/api/bills', params });
export const listSales = () => sx({ method: 'GET', url: '/api/staff/sales', params: { size: 500, page: 1 } });
export const listPartners = () => sx({ method: 'GET', url: '/api/partner', params: { mode: 'D' } });
export const changeBillPartner = (body) => sx({ method: 'POST', url: '/api/bill/change/partner', data: body });

// Giao hàng
export const collectDeliveries = (params) => sx({ method: 'GET', url: '/api/deliveries/collect', params });
export const createDelivery = (body) => sx({ method: 'POST', url: '/api/delivery', data: body });
export const myDeliveries = (params) => sx({ method: 'GET', url: '/api/deliveries/app', params });
export const changeDeliveryStatus = ({ shipment_code, delivery_status, delivery_note = '', batch_code = '', num_pieces, files = [] }) => {
  const fd = new FormData();
  fd.append('shipment_code', shipment_code);
  fd.append('delivery_status', delivery_status);
  fd.append('delivery_note', delivery_note);
  fd.append('batch_code', batch_code || '');
  if (num_pieces != null) fd.append('num_pieces', String(num_pieces));
  files.forEach((f) => fd.append('files', f, f.name || 'image.jpg'));
  return sx({ method: 'POST', url: '/api/delivery/invoices/app', data: fd });
};
export const reorderDeliveries = (sorts) => sx({ method: 'PUT', url: '/api/deliveries/change/index', data: { sorts } });
export const updateEstimateArrived = (code, expected_time) =>
  sx({ method: 'POST', url: '/api/deliveries/estimate-arrived/update', data: { code, expected_time } });

// Thông báo — GỘP của tài khoản chính + mọi tài khoản chỉ-nhận-thông-báo. Mỗi mục có accountId/accountName.
export const opsNotifications = () => opsReq(client.get('/ops/notifications'));
// Đánh dấu đã đọc trên ĐÚNG tài khoản nguồn của thông báo (accountId lấy từ mục đó).
export const markOpsNotificationsRead = (accountId, ids) =>
  opsReq(client.post('/ops/notifications/read', { accountId, ids }));
